import React from "react";
import { Route } from "react-router-dom";
import OverviewPage from "./views/OverviewPage";
import BgpReflectorsPage from "./components/Reflector/ReflectorsPage";
import BgpVisibilityPage from "./components/BGP/BgpVisibilityPage";
import LicensingPage from "./components/Licensing/LicensingPage";
import UsersPage from "../settings/account/components/Users/UsersPage";
import CustomersPage from "../settings/account/components/Customers/CustomersPage";
import RequestPage from "../settings/support/RequestPage";
import ReflectorDetailsPage from "./components/Reflector/ReflectorDetails/ReflectorDetailsPage";
import ClusterPage from "./components/Reflector/Cluster/ClusterPage";
import ClusterDetailsPage from "./components/Reflector/Cluster/ClusterDetails/ClusterDetailsPage";

export const ctxReflectorV2Routes = [
  <Route key="overview" path="reflector-v2/overview" element={<OverviewPage />} />,
  <Route key="bgp-reflectors" path="reflector-v2/management/bgp-reflectors" element={<BgpReflectorsPage />} />,
  <Route key="bgp-reflector-details" path="reflector-v2/management/bgp-reflectors/details/:id" element={<ReflectorDetailsPage />} />,
  <Route key="bgp-visibility" path="reflector-v2/management/bgp-visibility" element={<BgpVisibilityPage />} />,
  <Route key="licensing" path="reflector-v2/management/licensing" element={<LicensingPage />} />,
  <Route key="admin-center-licensing" path="reflector-v2/admin-center/management/licensing" element={<LicensingPage />} />,
  <Route key="payg" path="reflector-v2/management/licensing/payg" element={<LicensingPage />} />,
  <Route key="clusters" path="reflector-v2/management/clusters" element={<ClusterPage />} />,
  <Route key="cluster-details" path="reflector-v2/management/clusters/details/:id" element={<ClusterDetailsPage />} />,
  <Route key="users" path="account/users" element={<UsersPage />} />,
  <Route key="customers" path="account/customers" element={<CustomersPage />} />,
  <Route key="request" path="request" element={<RequestPage />} />,
]; 